const MAILTO_PREFIX = 'mailto:';
const HTTP_PROTOCOL_PATTERN = /^http:\/\//i;
const HTTPS_PROTOCOL_PATTERN = /^https:\/\//i;
const GENERIC_SCHEME_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;
const PROTOCOL_RELATIVE_PATTERN = /^\/\//;

export const isMailtoLink = (value: string): boolean => {
    if (!value) {
        return false;
    }

    return value.trim().toLowerCase().startsWith(MAILTO_PREFIX);
};

export const normalizeUrlProtocol = (value: string): string => {
    if (!value) {
        return '';
    }

    const trimmedValue = value.trim();

    if (!trimmedValue || isMailtoLink(trimmedValue)) {
        return trimmedValue;
    }

    if (HTTP_PROTOCOL_PATTERN.test(trimmedValue)) {
        return trimmedValue.replace(HTTP_PROTOCOL_PATTERN, 'https://');
    }

    if (HTTPS_PROTOCOL_PATTERN.test(trimmedValue)) {
        return trimmedValue;
    }

    if (PROTOCOL_RELATIVE_PATTERN.test(trimmedValue)) {
        return `https:${trimmedValue}`;
    }

    if (GENERIC_SCHEME_PATTERN.test(trimmedValue)) {
        return trimmedValue;
    }

    return `https://${trimmedValue}`;
};

export const isValidExternalUrl = (value: string): boolean => {
    if (!value) {
        return true;
    }

    if (isMailtoLink(value)) {
        return true;
    }

    try {
        // URL parsing is enough here because the helper has already normalized missing protocols.
        // mailto links are handled above and should bypass URL parsing.
        const parsedUrl = new URL(normalizeUrlProtocol(value));
        return Boolean(parsedUrl);
    } catch (error) {
        return false;
    }
};

export default normalizeUrlProtocol;
